import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  workflow: {},
  workflowVersions: [],
  selectedWorkflowVersion: null,
  selectedCommit: null,
  selectedNode: null,
  selectedNodeOptions: null,
  startSettings: {
    period: null,
    time_at: null,
    day: null,
    week: [],
    custom: null,
    trigger_subtype: null,
    trigger_type: 'manual',
  },
  s3StorageEnabled: true,
  alertSettings: {
    enabled: false,
    rateCondition: '< 90',
    status: ['FAILURE'],
    pingUsers: [],
  },
  credentials: [],
  actionsOutputs: null,
  appointmentOptions: [],
  nodes: [],
  copyOfSavedNodes: [],
  movingNodeId: null,
  inputTaskQuestions: null,
  workflowEdited: false,
  runStatus: {},
  hideSettings: false,

  // loaders
  fetchWorkflowLoading: false,
  setInputTaskLoading: false,
  saveWorkflowLoading: false,
  updateWorkflowLoading: false,
  overwriteVersionLoading: false,
  fetchOutputModelsLoading: false,
  fetchAppointmentOptionsLoading: false,
  startWorkflowLoading: false,
  runWorkflowLoading: false,
  checkingAutomationWorkflowStatusLoading: false,
  executeSingleActionLoading: false,
  workflowVersionsLoading: false,
  publishWorkflowVersionLoading: false,
  selectWorkflowVersionLoading: false,
  updateWorkflowVersionLoading: false,
  deleteWorkflowVersionLoading: false,
  restoreCommitLoading: false,
  //
  openVersionModalFromOverwrite: false,
  openVersionModalFromRun: false,
});

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};
